import styled from "styled-components";
import { DeviceType } from "../../../utils/hooks/useDeviceHook";

const getConfirmationMessageModalDeviceWidth = (
  deviceType: DeviceType,
): string => {
  if (deviceType === "mobile") return "calc(100% - 10px);";
  return "362px";
};

export const ConfirmationModalMessageWrapper = styled.div<{
  deviceType: DeviceType;
}>`
  width: ${({ deviceType }) =>
    getConfirmationMessageModalDeviceWidth(deviceType)};
  height: auto;
  background: white;
  border-radius: 16px;
  text-align: center;
  box-shadow: 0 3px 7px rgba(0, 0, 0, 0.3);
`;
export const ConfirmationModalContentWrapper = styled.div`
  margin: 24px;
`;
